var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoegoRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 82",
    x1: 48.41,
    y1: 7.19,
    x2: 63.93,
    y2: 83.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f6f8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36.45,97.66c-2.89-2.36-6.33-3.87-9.96-4.73-9.35-2.2-16.32-10.61-16.32-20.61V22C10.16,10.3,19.64.82,31.34.82h50.33c11.69,0,21.17,9.48,21.17,21.17v50.33c0,10.01-6.98,18.41-16.32,20.61-3.63.85-7.07,2.37-9.96,4.73l-16.09,13.11c-2.31,1.88-5.61,1.88-7.92,0l-16.09-13.11Z",
    fill: "#ceb01d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.51,10.2h50.15c6.51,0,11.8,5.29,11.8,11.8v50.33c0,6.51-5.29,11.8-11.8,11.8H31.34c-6.51,0-11.8-5.29-11.8-11.8V22.17c0-6.61,5.37-11.97,11.97-11.97Z",
    fill: "url(#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m34.15,24.31c-.69.18-1.64.49-2.1.69-2.57,1.13-5,3.45-6.22,5.95-1.1,2.25-1.34,3.32-1.33,5.92,0,2.02.05,2.32.55,3.79.78,2.3,1.76,3.75,4.26,6.33l2.17,2.24-1.27,5.43c-.7,2.99-1.25,5.45-1.23,5.47.02.02.88.1,1.92.18l1.88.14-1.66,4.21c-.92,2.32-1.65,4.27-1.62,4.35.02.07,2.71-3.13,5.96-7.12l5.92-7.25h-4.1l5.05-5.1c5.48-5.53,5.84-6.08,6.86-8.76.91-2.73.9-5.45-.02-8.21-1.28-3.85-4.36-6.82-8.38-8.09-1.7-.54-4.9-.62-6.64-.18Zm9.84,12.45c0,3.77-3.03,6.82-6.77,6.82s-6.77-3.05-6.77-6.82,3.03-6.82,6.77-6.82,6.77,3.05,6.77,6.82Z",
    fill: "#ceb01d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.86,57.15c-.65.7-1.67,1.11-3.17,1.11h0c-1.27.02-2.52-.3-3.62-.92l.85-1.83c.74.49,1.62.76,2.52.76,1.27,0,1.89-.7,1.89-1.97v-.31c-.24.37-.58.67-.97.88-.39.21-.83.32-1.28.32-1.77,0-3.2-1.42-3.2-3.73v-.03c0-2.32,1.43-3.74,3.12-3.74.44,0,.87.09,1.26.29.39.19.73.47.99.82v-.95h2.53v6.1c0,1.47-.28,2.5-.93,3.2Zm-3.62-4.28c.19.08.39.11.59.11h-.02c.2,0,.4-.05.58-.13.18-.08.35-.2.49-.34.14-.15.24-.32.31-.5.07-.19.1-.39.08-.58v-.03c.01-.2-.01-.4-.08-.58-.07-.19-.17-.36-.31-.5s-.3-.26-.49-.34c-.18-.08-.38-.12-.59-.12-.2,0-.4.04-.59.12-.19.08-.35.2-.49.34s-.25.32-.31.51c-.07.19-.1.39-.08.59v.03c-.01.2.02.4.09.59.07.19.18.36.32.51s.31.26.5.34Z",
    fill: "#ceb01d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.85,51.85c0,2.28-1.68,4.2-4,4.2v-.03c-2.29,0-3.98-1.88-3.98-4.17s1.71-4.2,4-4.2,3.98,1.88,3.98,4.17v.03Zm-5.13,1.21c.28.34.69.55,1.13.6l.03-.03c.95,0,1.51-.81,1.51-1.78.02-.22,0-.44-.07-.65-.07-.21-.17-.4-.32-.57-.14-.17-.32-.31-.51-.41-.2-.1-.41-.16-.63-.18-.95,0-1.51.81-1.51,1.78v.03c-.04.44.09.87.38,1.21Z",
    fill: "#ceb01d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.48,57.15c-.65.7-1.67,1.11-3.17,1.11h.03c-1.27.02-2.52-.3-3.62-.92l.84-1.85c.74.49,1.62.76,2.52.76,1.27,0,1.89-.7,1.89-1.97v-.31c-.24.37-.58.67-.97.88-.39.21-.83.32-1.28.32-1.77,0-3.2-1.42-3.2-3.73v-.03c0-2.32,1.43-3.74,3.12-3.74.44,0,.87.09,1.26.29.39.19.73.47.99.82v-.95h2.53v6.1c0,1.47-.3,2.52-.96,3.23Zm-3.57-4.29c.19.08.39.12.59.12.2,0,.4-.05.58-.13.18-.08.35-.2.49-.34.14-.15.24-.32.31-.5.07-.19.1-.39.08-.58v-.03c.01-.2-.01-.4-.08-.58-.07-.19-.17-.36-.31-.5-.14-.15-.3-.26-.49-.34-.18-.08-.38-.12-.59-.12-.2,0-.4.04-.59.12-.19.08-.35.2-.49.34-.14.15-.25.32-.31.51-.07.19-.1.39-.08.59v.03c-.01.2.02.4.09.58.07.19.18.36.31.5.14.14.31.26.49.34Z",
    fill: "#ceb01d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.5,51.85c0,2.28-1.68,4.17-4,4.17s-3.98-1.88-3.98-4.17,1.71-4.2,4-4.2,3.98,1.92,3.98,4.2Zm-4.63,1.62c.2.1.41.16.63.18.93.08,1.51-.84,1.51-1.81.02-.22,0-.44-.07-.65-.07-.21-.17-.4-.32-.57-.14-.17-.32-.31-.51-.41-.2-.1-.41-.16-.63-.18-.95,0-1.51.81-1.51,1.78v.03c-.02.22,0,.44.07.65.07.21.17.4.32.57.14.17.32.31.51.41Z",
    fill: "#ceb01d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.11,47.94h-7.02v1.92h7.02v-1.92Z",
    fill: "#ceb01d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.1,50.96h7.02v1.92h-7.02v-1.92Z",
    fill: "#ceb01d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.1,54.04h7.02v1.91h-7.02v-1.91Z",
    fill: "#ceb01d"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 13,
    r: 10,
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 13,
    r: 7,
    fill: "#f43131"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoegoRed);
export default __webpack_public_path__ + "static/media/Goego_red.c5c9c697c0f64ae475cf9842fb54bc3f.svg";
export { ForwardRef as ReactComponent };